<template>
  <div style="height: 500px;">
    <img src="./Oven.jpg" height="45">
    <h5>МУ210 401</h5>
    <small>Дискретный вывод</small>
    <div class="m-1" v-if="shares">
      <span v-if="shares.online" class="badge bg-success">ONLINE</span>
      <span v-if="!shares.online" class="badge bg-danger">OFFLINE</span>
    </div>
            <hr>
    <div class="row" v-if="shares">
      <div class="col">
      <!-- <ul class="list-group"> -->
        <div v-for="n in 8" :key="id + 'UL' + n" class="text-center  mb-2">
          <span class="badge bg-secondary mb-1 mt-1" v-bind:class="{ 'bg-secondary': !shares.do[n-1], 'bg-danger': shares.do[n-1]  }">{{n}}</span>
        </div>
      <!-- </ul> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MU210-401',
  props: ['info','shares','id']
}
</script>
<style scoped>
</style>
